export type AggregatedMonitoring = {
  type: AggregatedMonitoringStatus;
  count: number;
};

export enum AggregatedType {
  Devices = 'Devices',
  Gateways = 'Gateways',
  Systems = 'Systems',
  Connectors = 'Connectors',
  ConnectorsAndGateways = 'ConnectorsAndGateways',
}

export enum AggregatedMonitoringStatus {
  Red = 'Red',
  Orange = 'Orange',
  Green = 'Green',
  Grey = 'Grey',
}
